
import React from 'react';
import { useFormContext } from "react-hook-form";
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { HomeIcon, UsersIcon, BedIcon, LucideIcon } from 'lucide-react';

interface TotalDisplayProps {
  label: string;
  fieldName: string;
  value: string;
  readOnly?: boolean;
  icon?: LucideIcon;
}

const TotalDisplay = ({ label, fieldName, value, readOnly = false, icon: Icon = HomeIcon }: TotalDisplayProps) => {
  const { register } = useFormContext();
  
  return (
    <Card className="hover:bg-gray-50 transition-colors border border-gray-200 shadow-sm">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon size={16} className="text-blue-600" />
            <span className="text-sm font-medium text-gray-700">{label}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-lg font-semibold text-blue-600">{value}</span>
            <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200 text-xs">
              {label.includes('Plazas') ? 'Plazas' : 'Unidades'}
            </Badge>
          </div>
        </div>
        {/* Campo oculto para el formulario */}
        <input 
          {...register(fieldName)}
          value={value}
          type="hidden"
        />
      </CardContent>
    </Card>
  );
};

export default TotalDisplay;
